// @flow

import * as React from 'react';
import OptionManager from "../common/OptionManager";

import type {ComponentMeta, UnmountHandler} from "../common/CommonTypes";
import DropDownInput from "./DropDownInput";
import CalculationSectionHeader from "./CalculationSectionHeader";
import ReactAI from 'react-appinsights';

type Props = {
    optionManager: OptionManager,

    onChange: (event: SyntheticEvent<>) => void,
    onBlur: (event: SyntheticEvent<>) => void,
    onUnmount: UnmountHandler,

    techniquesToCompare: number,

    techniquesToCompareMeta: ComponentMeta,

    phaseNr: number,

};

class CalculationTechInput extends React.Component<Props> {

    render() {

        const optionManager = this.props.optionManager;

        const onChange = this.props.onChange;
        const onBlur = this.props.onBlur;
        const onUnmount = this.props.onUnmount;

        const techniquesToCompare = this.props.techniquesToCompare;

        return (

            <div id={ `tech-choice-${this.props.phaseNr}` } className="calculation-tech-choice">

                <CalculationSectionHeader text="Val av teknik" headerLevel={3}/>

                <DropDownInput htmlName="techniquesToCompare"
                               onChange={onChange}
                               onBlur={onBlur}
                               onUnmount={onUnmount}
                               labelText="Jämför traditionell schaktning med"
                               helpHtml={this.getHelpHtml()}
                               phaseNr={this.props.phaseNr}
                               value={techniquesToCompare}
                               values={optionManager.availableSelections.techniquesToCompare}
                               meta={this.props.techniquesToCompareMeta} />


            </div>
        );

    }
    
    getHelpHtml() {
        return (`<div>
                <p>Välj en eller flera NoDig-tekniker att jämföra med.</p>
                <p>Rörtyper som kan förnyas med respektive NoDig-teknik:</p>
                <ul>
                    <li>Flexibla foder - avlopp och dagvatten</li>
                    <li>Rörspräckning - alla</li>
                    <li>Styrd borrning - alla</li>
                    <li>Sliplining - vatten</li>
                    <li>PU-liner - vatten</li>
                </ul>
            </div>`);
    }

}

export default ReactAI.withTracking(CalculationTechInput);



// WEBPACK FOOTER //
// ./src/components/CalculationTechInput.js